module.exports = __webpack_public_path__ + "img/accessories-d.2a5541d2.svg";